import React from "react";
import ErrorSuccessModal from ".";
import { Text } from "../../config";

const ErrorModal = ({
  setClose,
  onButtonClick,
  headerText = Text.ooops,
  subheaderText = Text.sorrySomethingWentWrongPleaseTryAgain,
  buttonText = Text.tryAgain,
  icon,
}) => {
  return (
    <ErrorSuccessModal
      icon={icon}
      setClose={setClose}
      headerText={headerText}
      subheaderText={subheaderText}
      buttonText={buttonText}
      onButtonClick={onButtonClick}
    />
  );
};

export default ErrorModal;
